// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
    .print-button {
      display: none;
    }
  }
  @media print {
    .back-button {
      display: none;
    }
    .mail-preview{
      display: none;
    }
    input{
        border:2px solid black !important;
    }
    .textarea{
        border:2px solid black !important;
    }
  h5{
      display: none;
    }
    .btn{
      display: none;
    }
  }

  @media print {
    .record {
      page-break-before: always;
    }
  }
  

  @media print {
    .sidebar {
      display: none; /* Hide the sidebar */
    }
  
    .content {
      margin-left: 0; /* Remove any left margin that was applied to account for the sidebar */
      padding: 20px; /* Add some padding for better readability */
    }
  
    /* Adjust other styles as needed for print */
  }
  

p{
    line-height: 1.5;
}

li{
    line-height: 1.5;
}

.p2{
    line-height: 1.2;
}
ul{
    line-height: 1.5;
}

body {
    font-family: Arial, sans-serif;
    background-color: #f4f4f4;
    margin: 0;
    padding: 0;
  }
  
  input, button {
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border: 1px solid #ddd;
  }
  
  button {
    background-color: #007BFF;
    color: white;
    cursor: pointer;
  }
  
  button:hover {
    background-color: #0056b3;
  }
  
  .back-button {
    background-color: #dc3545;
  }
  
  .back-button:hover {
    background-color: #c82333;
  }
  
  .print-button {
    background-color: #28a745;
  }
  
  .print-button:hover {
    background-color: #218838;
  }
  
  .record {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px;
    margin: 10px 0;
  }
  
  .record:hover {
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
  }
  
  /* Add this to your existing CSS file or create a new one */
.print-styles {
    @media print {
      input[type="text"] {
        border-style: double;
      }
  
      textarea {
        border-style: double;
      }
    }
  }
  
  body {
    font-size: 16px;
    text-align: left;
  }
  
  /* You can use media queries to adjust styles based on the screen size */
  @media screen and (max-width: 768px) {
    /* Adjust styles for smaller screens */
    body {
      font-size: 14px;
    }
  
    /* Add more responsive styles as needed */
  }`, "",{"version":3,"sources":["webpack://./src/components/letter/Letter2.css"],"names":[],"mappings":"AAAA;IACI;MACE,aAAa;IACf;EACF;EACA;IACE;MACE,aAAa;IACf;IACA;MACE,aAAa;IACf;IACA;QACI,iCAAiC;IACrC;IACA;QACI,iCAAiC;IACrC;EACF;MACI,aAAa;IACf;IACA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;;;EAGA;IACE;MACE,aAAa,EAAE,qBAAqB;IACtC;;IAEA;MACE,cAAc,EAAE,uEAAuE;MACvF,aAAa,EAAE,4CAA4C;IAC7D;;IAEA,4CAA4C;EAC9C;;;AAGF;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,oCAAoC;EACtC;;EAEA,2DAA2D;AAC7D;IACI;MACE;QACE,oBAAoB;MACtB;;MAEA;QACE,oBAAoB;MACtB;IACF;EACF;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,wEAAwE;EACxE;IACE,sCAAsC;IACtC;MACE,eAAe;IACjB;;IAEA,yCAAyC;EAC3C","sourcesContent":["@media print {\r\n    .print-button {\r\n      display: none;\r\n    }\r\n  }\r\n  @media print {\r\n    .back-button {\r\n      display: none;\r\n    }\r\n    .mail-preview{\r\n      display: none;\r\n    }\r\n    input{\r\n        border:2px solid black !important;\r\n    }\r\n    .textarea{\r\n        border:2px solid black !important;\r\n    }\r\n  h5{\r\n      display: none;\r\n    }\r\n    .btn{\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  @media print {\r\n    .record {\r\n      page-break-before: always;\r\n    }\r\n  }\r\n  \r\n\r\n  @media print {\r\n    .sidebar {\r\n      display: none; /* Hide the sidebar */\r\n    }\r\n  \r\n    .content {\r\n      margin-left: 0; /* Remove any left margin that was applied to account for the sidebar */\r\n      padding: 20px; /* Add some padding for better readability */\r\n    }\r\n  \r\n    /* Adjust other styles as needed for print */\r\n  }\r\n  \r\n\r\np{\r\n    line-height: 1.5;\r\n}\r\n\r\nli{\r\n    line-height: 1.5;\r\n}\r\n\r\n.p2{\r\n    line-height: 1.2;\r\n}\r\nul{\r\n    line-height: 1.5;\r\n}\r\n\r\nbody {\r\n    font-family: Arial, sans-serif;\r\n    background-color: #f4f4f4;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n  \r\n  input, button {\r\n    padding: 10px;\r\n    margin: 10px 0;\r\n    border-radius: 5px;\r\n    border: 1px solid #ddd;\r\n  }\r\n  \r\n  button {\r\n    background-color: #007BFF;\r\n    color: white;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  button:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  .back-button {\r\n    background-color: #dc3545;\r\n  }\r\n  \r\n  .back-button:hover {\r\n    background-color: #c82333;\r\n  }\r\n  \r\n  .print-button {\r\n    background-color: #28a745;\r\n  }\r\n  \r\n  .print-button:hover {\r\n    background-color: #218838;\r\n  }\r\n  \r\n  .record {\r\n    background-color: #fff;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    padding: 10px;\r\n    margin: 10px 0;\r\n  }\r\n  \r\n  .record:hover {\r\n    box-shadow: 0 0 10px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  /* Add this to your existing CSS file or create a new one */\r\n.print-styles {\r\n    @media print {\r\n      input[type=\"text\"] {\r\n        border-style: double;\r\n      }\r\n  \r\n      textarea {\r\n        border-style: double;\r\n      }\r\n    }\r\n  }\r\n  \r\n  body {\r\n    font-size: 16px;\r\n    text-align: left;\r\n  }\r\n  \r\n  /* You can use media queries to adjust styles based on the screen size */\r\n  @media screen and (max-width: 768px) {\r\n    /* Adjust styles for smaller screens */\r\n    body {\r\n      font-size: 14px;\r\n    }\r\n  \r\n    /* Add more responsive styles as needed */\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
